var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:{center: _vm.blocked}},'div',_vm.$attrs,false),[(_vm.blocked)?_c('div',{staticClass:"blocked_message"},[_vm._v(" "+_vm._s(_vm.$t("GOE BLOCKED"))+" ")]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }